import "./TestimonialSection.scss";

const TestimonialSection = () => {
  return (
    <section className="testimonial-section">
      <div className="cost-section-leftTop">
        <h4>Our Vision</h4>
        <p>Empowering trust through next-generation <br /> digital innovation</p>
      </div>
      <div className="testimonial-container">
        <div className="testimonial-person">
          <div className="testimonial-avatar">
            <img
              src="/LandingPageImages/VikramRSingh.svg"
              alt="Vikram R Singh"
              className="avatar-image"
            />
          </div>
          <div className="testimonial-info">
            <p className="testimonial-name">Vikram R Singh</p>
            <p className="testimonial-role">CEO @Antier</p>
          </div>
        </div>
        <div className="testimonial-content">
          <img src="/LandingPageImages/quote-icon.svg" alt="Quote Icon" />
          <h2 className="testimonial-headline">
            Redefining Exam Integrity Through Blockchain
          </h2>
          <p className="testimonial-quote-text">
            To create a completely secure and transparent examination ecosystem where students
            can pursue their dreams without fear of unfair practices, and institutions can maintain
            their credibility through unassailable blockchain technology. We envision a future where
            every examination is a true test of knowledge and capability, not a victim of fraud or manipulation.
          </p>
        </div>
      </div>
    </section>
  );
};

export default TestimonialSection;
